import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { Form as FormFinal, Field } from 'react-final-form';
import { Button, Alert, Card, Form, Col, Spinner, Table } from 'react-bootstrap';
import { CommentEdit } from '@styled-icons/boxicons-regular/CommentEdit';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import { ContentCopy } from '@styled-icons/material/ContentCopy';

//Actions
import { pesquisa as pesquisahtmls, novoatualiza as novoatualizahtmls, pesquisaTiposEmails, pesquisaPalavrasChaves } from '../../../../actions/html/modelos';

//Components
import { campotexto, camposelectsearch, campoeditor } from '../../../../components/forms/campos/campos';

//Utils
import { getEvento } from '../../../../utils/eventosession';

//Helpers
import { TelaModalLivre } from '../../../../helpers/TelaModal';

const FormHtmlGerenciamento  = (props) => {

    const [show, handleCloseModal] = useState(false);
    const [chaves, setPalavrasChaves] = useState(false);
    const [showGravado, handleCloseModalGravado] = useState(false);
    const [modeloscadastrados, setModelosEvento] = useState(false);
    const [copied, setCopied] = useState({});
    const [tipos, setTipos] = useState({});

    const evento = getEvento();

    useEffect(() => {
        load();
        getChaves();
    },[]);

    useEffect(() => {
        const result = props.resulttipos.length&&props.resulttipos.map(itens => {return {label: `${itens.tipo+' - '+itens.descricao}`, id: `${itens.tipo}`}});
        setTipos(result);
    },[props.resulttipos]);

    useEffect(() => {
        load();
    },[props.novoatualiza]);

    const load = async () => {
        const result = await props.pesquisahtmls({idevento: evento.idevento, idpromotora: evento.idpromotora});
        setModelosEvento(result.filter(itens => (itens.idevento!==1)));
        props.pesquisaTiposEmails({idpromotora: evento.idpromotora});
    }

    const getChaves = async () => {
        setPalavrasChaves(await props.pesquisaPalavrasChaves({idpromotora: evento.idpromotora}));
    }
    
    const handleSubmit = async (dadosform, form) => {
        const dados = {
            idevento: evento.idevento,
            idpromotora: evento.idpromotora,
            ...dadosform
        }
        
        await props.novoatualizahtmls(dados);
        setTimeout(() => {
            form.reset()
            handleCloseModalGravado(true);
        },500);
    }

    const handleModal = () => {
        handleCloseModal(show?false:true);
        setCopied({});
    }

    const handleModalGravado = () => {
        handleCloseModalGravado(showGravado?false:true);
        setCopied({});
    }

    const handleTipoSelecionado = (tipo,form) => {        
        const dados = props.resultpesquisaemail.filter(itens => {
            if(tipo.idevento!==1){
                return itens.idevento!==1&&itens.tipo===tipo;
            }else{
                return itens.tipo===tipo;
            }
        });
        console.log(dados);
        if(dados[0]){
            form.change('corpoemail', dados[0].corpoemail);            
            form.change('Idemail', dados[0].idevento===1?'':dados[0].Idemail);
            form.change('de', dados[0].de);            
            form.change('assunto', dados[0].idevento===1?'':dados[0].assunto);
        }else{
            form.change('corpoemail', '');
            form.change('Idemail', '');
            form.change('de', '');
            form.change('asssunto', '');
        }
    }

    const handleResetForm = (form) => {        
        form.reset();
        setTipos({});
    }
        
    return (
        <>
        <TelaModalLivre handleCloseModal={handleModal} show={show} titulo="Palavras chaves">
            <>            
                <Card>
                    <Card.Title></Card.Title>
                    {chaves&&chaves.map(chave => (
                        <CopyToClipboard key={chave.chaves} text={chave.chaves} onCopy={() => setCopied({nome: chave.chaves})}>
                            <Alert variant={`${copied&&copied.nome===chave.chaves?"info":"dark"}`} className={`${copied&&copied.nome===chave.chaves?"font-weight-bold":""}`}>
                                <ContentCopy size="20" style={{cursor: 'pointer'}} />{chave.chaves}{`${copied&&copied.nome===chave.chaves?" copiado":""}`}
                            </Alert>
                        </CopyToClipboard>    
                    ))}
                </Card>
            </>
        </TelaModalLivre>        
        <FormFinal
        onSubmit={handleSubmit}
        render={({form, handleSubmit, submitting}) => {            
            return (                
                <Card>                        
                    <Card.Header><Card.Title>Edição de E-mails e HTML</Card.Title></Card.Header>                    
                    <TelaModalLivre handleCloseModal={handleModalGravado} show={showGravado} titulo="Palavras chaves">
                        <Alert variant="success">Gravado com sucesso</Alert>
                    </TelaModalLivre>                    
                    <Card.Body>      
                        {modeloscadastrados!==false?
                        <Table striped bordered hover className="col col-lg-4">
                            <thead>
                                <tr>                            
                                <th>Modelo</th>
                                <th>Editar</th>                            
                                </tr>
                            </thead>                        
                            <tbody>
                                {modeloscadastrados.map(itens => (
                                    <tr key={itens.Idemail}>
                                        <td>{itens.tipo}</td>
                                        <td><CommentEdit style={{cursor: "pointer"}} size="35" type="button" onClick={() => handleTipoSelecionado(itens.tipo, form)} /></td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        :
                        null
                        }                  
                        <form onSubmit={(dados) => (handleSubmit(dados,form))}>
                            <Field type="hidden" name="Idemail" component={campotexto} />
                            <Form.Row>                            
                                <Form.Group controlId="tipo" as={Col} md="8">
                                    <Field name="tipo" id="tipo" label="Pesquisa Modelo" component={camposelectsearch}
                                        options={tipos}
                                        placeholder="Selecione o modelo"
                                        form={form}
                                        onChange={(value) => {
                                            handleTipoSelecionado(value, form)
                                        }}
                                    />
                                </Form.Group>                            
                            </Form.Row>
                            <Form.Row className='mb-4'>
                                <Form.Group as={Col}>
                                    <Button type="button" onClick={() => handleCloseModal(true)}>Palavras Chaves</Button>
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group controlId="de" as={Col} md="4">
                                    <Field type="text" label="De" name="de" component={campotexto} />
                                </Form.Group>
                                <Form.Group controlId="assunto" as={Col} md="4">
                                    <Field type="text" label="Assunto" name="assunto" component={campotexto} />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group controlId="corpoemail" as={Col} md="8">
                                    <Field name="corpoemail" label="HTML" component={campoeditor} form={form} />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row className="text-center">
                                <Form.Group controlId="corpo" as={Col} md="8">
                                    <Button 
                                    type="submit" 
                                    block
                                    disabled={submitting}
                                    >
                                        {submitting?<Spinner animation="border" />:'Confirmar'}
                                    </Button>
                                    <Button 
                                    type="button" 
                                    onClick={() => {
                                        handleResetForm(form);
                                    }}
                                    block                                    
                                    >
                                        Novo
                                    </Button>
                                </Form.Group>
                            </Form.Row>
                        </form>
                    </Card.Body>
                </Card>                
            )
        }}
        >
        </FormFinal>
        </>
    );
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks,
        novoatualiza: state.emailNovaAtualizaReducer,
        resultpesquisaemail: state.emailReducerPesquisa,
        resulttipos: state.emailReducerPesquisaTiposEmails
    }
}

export default connect(mapStateToProps, { pesquisahtmls, novoatualizahtmls, pesquisaTiposEmails, pesquisaPalavrasChaves })(FormHtmlGerenciamento);